import * as React from 'react';
import { TApiProcessCategory } from '../../types/Process';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

interface ICategoryDropdownProps {
  category: string;
  handleCategoryChange: (event: SelectChangeEvent<string>) => void;
  categories: Array<TApiProcessCategory>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(3, 0, 1),
      width: '100%',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    label: {
      backgroundColor: 'white',
      padding: '0 .2rem',
    },
  })
);

const CategoryDropdown: React.FC<ICategoryDropdownProps> = (
  props
): JSX.Element => {
  const classes = useStyles({});
  const { t } = useTranslation();

  return (
    <FormControl variant='outlined' className={classes.formControl}>
      <InputLabel
        id='process-category-label'
        shrink
        className={classes.label}
      >
        {t('process.category.select.label')}
      </InputLabel>
      <Select
        labelId='process-category'
        id='process-category'
        displayEmpty
        value={props.category}
        onChange={props.handleCategoryChange}
        label={t('process.category.select.label')}
        defaultValue={''}
      >
        <MenuItem value={''} selected>
          <em>{t('process.category.select.all')}</em>
        </MenuItem>
        {props.categories.map((category) => {
          return (
            <MenuItem key={category.id} value={category.id}>
              {category.nameDa}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default CategoryDropdown;